module.exports = __webpack_public_path__ + "img/book-6.7249d722.png";